import { AreaPresenter } from '@/presenters/AreaPresenter';
import { FilterKey } from '@studyportals/search-filters';
import { RouteFragmentDetails } from '../RouteFragmentDetails';
import { RouteFilter } from '../RouteFilter';
import { RouteFragment } from '../RouteFragment';
import { RouteParams } from '../RouteParams';

export class RouteArea extends RouteFilter {

	public static readonly fragmentType: typeof RouteArea = RouteArea;

	public constructor() {
		super('Area', FilterKey.AREA, new RouteFragmentDetails(RouteParams.AREA, AreaPresenter.allWithPaths()));
	}

	public instantiate(): RouteFragment {
		return new RouteArea();
	}
}
